// ─── ICON COMPONENT ───────────────────────────────────────────────────────────
// No React import needed — Vite's automatic JSX transform handles it.
//
//  Lightweight inline SVG icon set. Add new icons by extending the `paths` map.
//  All SVGs are rendered aria-hidden so the parent element carries any label.
//

const Icon = ({ name, size = 18, color = 'currentColor', fill = 'none' }) => {
  const paths = {
    plus:       'M12 5v14M5 12h14',
    edit:       'M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z',
    trash:      'M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6',
    eye:        'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z',
    back:       'M19 12H5M12 19l-7-7 7-7',
    close:      'M18 6L6 18M6 6l12 12',
    check:      'M20 6L9 17l-5-5',
    user:       'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z',
    logout:     'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9',
    horizontal: 'M3 12h18M3 7h5M16 7h5M3 17h5M16 17h5',
    vertical:   'M12 3v18M7 3v5M7 16v5M17 3v5M17 16v5',
    zigzag:     'M12 2v20M4 7h8M12 12h8M4 17h8',
    storyline:  'M3 6h18M3 10h18M8 14h8M10 18h4',
    newspaper:  'M3 5h18v15H3zM3 9h18M12 9v11',
    palette:    'M12 22a10 10 0 0 1 0-20c5.52 0 10 4.03 10 9a6 6 0 0 1-6 6h-1.77a1 1 0 0 0-.72 1.7 1.15 1.15 0 0 1-.28 1.8A4.34 4.34 0 0 1 12 22zM6.5 13a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM8 8.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM12 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM16 8.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z',
    image:      'M21 19V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2zM8.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM21 15l-5-5L5 21',
    save:       'M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2zM17 21v-8H7v8M7 3v5h8',
    info:       'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM12 8h.01M11 12h1v4h1',
    calender:   'M8 2v3M16 2v3M3 8h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z',
    duplicate:  'M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-2M16 4h2a2 2 0 0 1 2 2v10M10 4h4v4h-4z',
    sun:        'M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10zM12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42',
    moon:       'M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z',
    lock:       'M19 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2zM7 11V7a5 5 0 0 1 10 0v4',
    globe:      'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z',
    heart:      'M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z',
    message:    'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z',
    link:       'M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71',
    reply:      'M9 17l-5-5 5-5M20 18v-2a4 4 0 0 0-4-4H4',
    feed:       'M21 4H3M21 9H3M21 14H3M21 19H3',
    pencil:     'M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4z',
    search:     'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM21 21l-4.35-4.35',
    bell:       'M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 0 1-3.46 0',
    userPlus:   'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM19 8v6M22 11h-6',
    userCheck:  'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM17 11l2 2 4-4',
    users:      'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75',
    share:      'M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8M16 6l-4-4-4 4M12 2v13',
    history:    'M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8M3 3v5h5M12 7v5l3 3',
    moreHorizontal: 'M5 12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM12 12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM19 12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z',
    grip:       'M9 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM15 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM9 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM15 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM9 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM15 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2z',
    keyboard:   'M20 5H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zM6 10h2M10 10h2M14 10h2M18 10h2M7 14h10',
    map:        'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z',
    circular:   'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM12 2v4M12 18v4M2 12h4M18 12h4M12 12l-3-3',
    swimlane:   'M3 6h18M3 11h12M3 16h15',
    tree:       'M12 3v7M12 10H6v7M12 10h6v7M6 17v3M18 17v3M12 17v3',
    filmstrip:  'M2 6h2v12H2zM20 6h2v12h-2zM5 4h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zM6 8h12v8H6zM5 4v2M5 18v2M9 4v2M9 18v2M15 4v2M15 18v2M19 4v2M19 18v2',
    spine:      'M4 19.5A2.5 2.5 0 0 1 6.5 17H20M4 19.5A2.5 2.5 0 0 0 6.5 22H20V2H6.5A2.5 2.5 0 0 0 4 4.5v15zM8 7h8M8 11h8M8 15h5',
    shield:     'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z',
    download:   'M3 15v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4M12 3v12M8 12l4 4 4-4',
    upload:     'M3 15v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4M12 15V3M8 6l4-4 4 4',
    document:   'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M16 13H8M16 17H8M10 9H8',
    warning:    'M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0zM12 9v4M12 17h.01',
    fileText:   'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M16 13H8M16 17H8M10 9H8',
    code:       'M16 18l6-6-6-6M8 6l-6 6 6 6',
    copy:       'M20 9h-9a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2zM5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1',
    zoomIn:     'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM21 21l-4.35-4.35M11 8v6M8 11h6',
    zoomOut:    'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM21 21l-4.35-4.35M8 11h6',
    maximize2:  'M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7',
    layers:     'M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5',
    minimap:    'M9 4H3v16l6-4 6 4 6-4V4l-6 4-6-4z',
    compress:   'M4 14h6v6M14 4h6v6M20 4l-7 7M4 20l7-7',
    expand2:    'M15 3h6v6M4 18l7-7M14 15l6 5M9 21H3v-6',
    calToday:   'M8 2v3M16 2v3M3 8h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2z',
    chevronR:   'M9 18l6-6-6-6',
    chevronL:   'M15 18l-6-6 6-6',
    flag:       'M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1zM4 22v-7',
    ban:        'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM4.93 4.93l14.14 14.14',
    at:         'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0zM12 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm9 0v1.5A3.5 3.5 0 0 1 12 9',
    bookmark:   'M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z',
    sparkles:   'M5 3l1.5 4.5L2 10l4.5 2.5L5 17l4-2.5 4 2.5-1.5-4.5L16 10l-4.5-2.5zM19 3v4M21 5h-4M19 15v4M21 17h-4',
  };

  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d={paths[name] || ''} />
    </svg>
  );
};

export default Icon;
